<template>
  <div style="height: 100%;" @touchstart="toRoute"  @click="toRoute">
    <!--WUE实时值-->
    <label style="margin-top: 15px;font-weight: bold;margin-left: 30px;">WUE实时值</label>
    <gauge-chart :data="data" ref="pieChart" style="height: 70%;" v-if="data" :route="route"
                 :itPower="itPower" :power="power" :pueValue="pueValue" :extendData="extendData" :id="id" :tagCode="tagCode"></gauge-chart>
    <no-data style="text-align: center;margin-top: 5%" v-else></no-data>

  </div>
</template>

<script>
import gaugeChart from "@/components/echarts/GaugeChart";
import {getRealTimePue} from "@/network/ems-record.js"
import NoData from "@/components/NoData";
import {getSystematicByParent} from "@/network/systematic";
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "Wue",
  mixins: [platenLayoutEdit],
  components: {gaugeChart, NoData},
  data() {
    return {
      data: null,
      route: '',
      itPower: 0,
      power: 0,
      pueValue: 0,
      id: 'wueChart',
      tagCode: 'water',
    }
  },
  created() {
    this.getData();
    this.getLinkage();
    this.$store.dispatch('addIntervalObj', {'getPUE:500000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getPUE')
  },
  methods: {
    //获取子系统地址
    getLinkage() {
      getSystematicByParent().then(res => {
        let system = res.data.filter(system => system.appName == "能耗系统")[0];
        if (system) {
          this.route = system.website + '#/pueAnalyse';
        }
      })
    },
    toRoute() {
      if (this.isPlatenLayoutEditing) return
      if (this.route) {
        window.open(this.route, '_blank')
      }
    },
    getData() {
      getRealTimePue(null, 'water').then(res => {
        if (res.code === 0 && res.data !== null) {
          this.data = res.data;
          this.itPower = res.data.itPower
          this.power = res.data.power
          this.pueValue = res.data.pueValue
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
